<template>
    <div class="page-scan-in-list">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">澳門倉庫</div>
            <div class="breadcrumb-item">已出庫</div>
        </div>

        <div class="card-block">
            <Form inline class="pg-form-inline">
                <FormItem>
                    <Select size="small" placeholder="提貨櫃點" v-model="form.arrive">
                        <Option :value="item.ReceivingID" v-for="(item, index) in pickAddress"
                                :key="item.ReceivingID">({{item.cainiao_match}}) {{item.ReceivingName}}
                        </Option>
                    </Select>
                </FormItem>
              
                <FormItem>
                    <DatePicker class="no-suffix" type="datetime" size="small" :clearable="false" placeholder="澳門倉庫-出庫開始日期" v-model="form.start_time" value-format="yyyy-MM-dd hh:mm:ss" :editable="false" style='width: 100%;'></DatePicker>
                </FormItem>
                <FormItem>-</FormItem>
                <FormItem>
                    <DatePicker class="no-suffix" type="datetime" size="small" :clearable="false" placeholder="澳門倉庫-出庫結束日期" v-model="form.end_time" value-format="yyyy-MM-dd hh:mm:ss" :editable="false" style='width: 100%;'></DatePicker>
                </FormItem>
            </Form>

            <Form inline class="pg-form-inline form-input-wrap">
                <FormItem>
                    <label class="input-label">快遞單號</label>
                    <Input size="small" clearable v-model="form.odd_numbers" @keyup.enter.native="handleSearch()"></Input>
                </FormItem>
                <FormItem>
                    <label class="input-label">客戶名稱</label>
                    <Input size="small" clearable v-model="form.recipient_contacts" @keyup.enter.native="handleSearch()"></Input>
                </FormItem>
                <FormItem>
                    <label class="input-label">客戶電話</label>
                    <Input size="small" clearable v-model="form.phone" @keyup.enter.native="handleSearch()"></Input>
                </FormItem>
                <FormItem>
                    <label class="input-label">袋號</label>
                    <Input size="small" clearable v-model="form.sack_number" @keyup.enter.native="handleSearch()"></Input>
                </FormItem>
                <FormItem>
                    <div class="pg-btn-wrap">
                        <div class="pg-btn style1" @click="handleSearch">搜索</div>
                        <!-- <a :href="exportLink" target="_blank" class="pg-btn style2" @click="handleExport" style="margin-left: 15px;">導出excel</a> -->
                    </div>
                </FormItem>
            </Form>
        </div>

        <div class="card-block pd-bt">
            <Spin fix class="pg-sub-loading" v-if="isLoading">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>
            <Table size="small"
                   border
                   no-data-text="暫無數據"
                   :columns="table.column"
                   :data="table.data">
               <!-- <template slot-scope="{ row, index }" slot="action">
                    <div class="pg-btn-wrap">
                        <div class="pg-btn style2" @click="handleEdit(index)">修改</div>
                        <div class="pg-btn style1" @click="handleDelete(index)">刪除</div>
                    </div>
                </template>-->
            </Table>

            <div class="pg-pagger">
                <Row>
                    <Col span="12" class="pagger-left">
                        <div class="pagger-total">總共{{totalCount}}條記錄</div>
                    </Col>
                    <Col span="12" class="pagger-right">
                        <!-- v-if="totalCount > curPageSize" -->
                        <div>
                            <div class="pagger-sizer">
                                <span>每頁</span>
                                <Select v-model="curPageSize" size="small" placeholder="數量"
                                        @on-change="handlePageSizeChange">
                                    <Option :value="10">10</Option>
                                    <Option :value="20">20</Option>
                                    <Option :value="30">30</Option>
                                    <Option :value="40">40</Option>
                                    <Option :value="50">50</Option>
                                </Select>
                            </div>

                            <div class="pagger-elevator">
                                <span>跳轉</span>
                                <Input size="small" v-model="pageInput" @on-keyup="handlePageInput"
                                       @on-enter="handlePageEnter"/>
                            </div>

                            <Page size="small"
                                  :current="pageIndex"
                                  :page-size="curPageSize"
                                  :total="totalCount"
                                  @on-change="handlePageChange">
                            </Page>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    </div>
</template>

<script>
    import Store from '../../../assets/js/store.js'
    export default {
        data()
        {
            return {
                pickAddress: [],
                pageIndex: 1, //頁碼
                curPageSize: 10, //一頁數量
                totalCount: 1, //總條數
                pageInput: '', //輸入的頁碼
                isLoading: true, //Loading開關
                form: {
                    phone: '',
                    recipient_contacts: '',
                    start_time: '',
                    end_time: '',
                    odd_numbers: '',
                    arrive: Store.fetch().store_id,
                    goods_type: '',
                    sack_number: '',
                    username: '',
                    keywords: '',
                },
                table: {
                    column: [
						{
                            title: '快遞提貨點',
                            key: 'ReceivingName',
							sortable: true,
                            align: 'center',
                        },
                        {
                            title: '會員名稱',
                            key: 'recipient_contacts',
                            sortable: true,
                            align: 'center',
                        },
                        {
                            title: '電話號碼',
                            key: 'recipient_phone',
                            sortable: true,
                            align: 'center',
                        },
                        {
                            title: '出庫袋號',
                            key: 'sack_number',
							sortable: true,
                            align: 'center',
                        },
                        {
                            title: '單號',
                            key: 'odd_numbers',
							sortable: true,
                            align: 'center',
                        },
                        {
                            title: '泡重',
                            key: 'volume_weight',
                            sortable: true,
                            align: 'center',
                        },
                        {
                            title: '代收費',
                            key: 'amount',
                            sortable: true,
                            align: 'center',
                            className: 'demo-table-info-cell-name'
                        },
                        {
                            title: '到付運費',
                            key: 'freight_collect',
                            sortable: true,
                            align: 'center',
                            className: 'demo-table-info-cell-name'
                        },
                        {
                            title: '加收附加費',
                            key: 'surcharge_price',
                            sortable: true,
                            align: 'center',
                            className: 'demo-table-info-cell-name'
                        },
                        {
                            title: '出庫時間',
                            key: 'macao_originating_out_time',
							sortable: true,
                            align: 'center',
                        }
                    ],
                    data: []
                }
            };
        },
        mounted()
        {
            this.getPickAddress();
            this.getList();
        },
        methods: {
            getPickAddress()
            {
                this.$Rq.requestAuth({
                    url: this.$Api.pickAddress,
                    method: 'get',
                    data: {
                        company_id: 1,
                    }
                }).then((res) =>
                {
                    if (res.code == 0)
                    {
                        this.pickAddress = res.data.data;
                    }
                });
            },
            getList()
            {
                let form = this.form;

                this.isLoading = true;
                this.$Rq.requestAuth({
                    url: this.$Api.macaoInList,
                    method: 'post',
                    data: {
                        recipient_contacts: form.recipient_contacts,
                        phone: form.phone,
                        arrive: form.arrive,
                        odd_numbers: form.odd_numbers,
                        sack_number: form.sack_number,
                        offset: (this.pageIndex - 1) * this.curPageSize,
                        limit: this.curPageSize,
                        status: 1, //0:已入庫,1:已出庫
                        macao_originating: 2, //0:珠海倉, 1:澳門已入庫, 2:澳門已出庫
                    }
                }).then((res) =>
                {
                    this.isLoading = false;
                    if (res.code == 0)
                    {
                        let tempArr = [];
                        let resData = res.data.data;

                        for (let i = 0; i < resData.length; i++)
                        {
                            tempArr.push({
                                id: resData[i].id, //ID
                                odd_numbers: resData[i].odd_numbers, //單號
                                sack_number: resData[i].sack_number, //袋號
                                macao_originating_time: resData[i].macao_originating_time, //澳門倉庫入庫時間
                                macao_originating_out_time: resData[i].macao_originating_out_time, //澳門出庫時間
								ReceivingName: resData[i].store.ReceivingName,
                                recipient_phone: resData[i].recipient_phone,
                                recipient_contacts: resData[i].recipient_contacts,
                                amount: resData[i].amount,
                                volume_weight: resData[i].volume_weight,
                                freight_collect: resData[i].freight_collect,
                                surcharge_price: resData[i].surcharge_price,
                            });
                        }

                        this.totalCount = res.data.count;
                        this.table.data = tempArr;
                    }
                }).catch(() =>
                {
                    this.isLoading = false;
                });
            },

            handleSearch()
            {
                this.pageIndex = 1;
                this.getList();
            },

            handleEdit(index)
            {
                let tableData = this.table.data;
                this.$router.push({path: '/shopManageEdit?id=' + tableData[index].ReceivingID});
            },
            handleDelete(index)
            {
                this.$Modal.confirm({
                    title: '提示',
                    content: '確定刪除嗎？',
                    cancelText: '取消',
                    okText: '確定',
                    onOk: () =>
                    {
                        let tableData = this.table.data;
                        this.isSubmiting = true;

                        this.$Rq.requestAuth({
                            url: this.$Api.shopDelete + '/' + tableData[index].ReceivingID,
                            method: 'delete'
                        }).then((res) =>
                        {
                            this.isSubmiting = false;

                            if (res.code == 0)
                            {
                                this.$Utils.showSuccess(res.msg);

                                if (tableData.length <= 1 && this.pageIndex > 1)
                                {
                                    this.pageIndex -= 1;
                                }

                                this.getList();

                            } else
                            {
                                this.$Utils.showTipInfo(res.msg);
                            }
                        }).catch((err) =>
                        {
                            this.isSubmiting = false;
                        });

                    }
                });
            },

            //pager
            handlePageSizeChange(value)
            {
                this.pageIndex = 1;
                this.getList();
            },

            handlePageInput()
            {
                let value = ('' + this.pageInput).replace(/\D/g, '');
                let pageCount = Math.ceil(this.totalCount / this.curPageSize);
                if (value > pageCount)
                {
                    value = pageCount;
                }
                this.pageInput = value;
            },
            handlePageEnter()
            {
                if (this.pageInput == '' || this.pageInput == this.pageIndex) return;
                if (this.pageInput == 0)
                {
                    this.pageInput = 1;
                }
                this.pageInput = parseInt(this.pageInput);
                this.pageIndex = this.pageInput;
                this.getList();
            },

            handlePageChange(value)
            {
                this.pageIndex = value;
                this.getList();
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import 'ScanOutList';
</style>
<style>
    .ivu-table td.demo-table-info-column{
        background-color: #FFEBDE;
        color: #000;
    }
    .ivu-table td.demo-table-info-cell-name {
        background-color: #D6E7FF;
        color: #515A6E;
    }
    .ivu-table td.demo-table-info-cell-name-sum {
        background-color: #FFEBDE;
        color: #000;
    }
    .ivu-table .demo-table-error-row {
        background-color: #fcffd6;
        color: #515A6E;
    }
    .ivu-table .demo-table-info-row {
        background-color: #FFEBDE;
        color: #515A6E;
    }
    .ivu-table .demo-table-app-row {
        background-color: #e8ffd6;
        color: #515A6E;
    }
</style>